/**
 * `/sign-in` — mounts Clerk's prebuilt `<SignIn />` inside AuthLayout.
 *
 * As of 2026-05-30 Repancy is sign-up-first: `/` mounts `<SignUp />`
 * (via SignUpWindow) and this route is the secondary surface for
 * returning users who clicked the "Sign in" cross-link on the
 * sign-up card. Both use the same AuthLayout so screens look
 * identical except for the title-bar text.
 *
 * Public path — registered in `__root.tsx`'s `isPublicPath()` so the
 * sign-in gate doesn't try to render SignUpWindow over the top of
 * this route.
 *
 * Per CLAUDE.md: prebuilt only; no custom-flow hooks without explicit
 * user approval.
 */
import { createFileRoute } from '@tanstack/react-router';
import { SignIn } from '@clerk/react';
import type { ReactElement } from 'react';
import { AuthLayout } from '../components/auth/AuthLayout';

export const Route = createFileRoute('/sign-in')({
  component: SignInPage,
});

// Exported so the route-level test can import and render directly
// without depending on TanStack Router's `Route.options` type, which
// shifts between minor versions.
export function SignInPage(): ReactElement {
  return (
    <AuthLayout title="Sign in to Repancy">
      <SignIn
        signUpUrl="/"
        forceRedirectUrl="/?onboard=auto"
      />
    </AuthLayout>
  );
}
